'use strict';

const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
const ANIMATION_DURATION = 2000;
const ELEMENT_TYPE = {
  CIRCLE: 'circle',
  PATH: 'path'
};
const DEFAULTS = {
  scoreSize: 160,
  scoreRadius: 80,
  scorePadding: 2
};

var wooReviewScore;
var currentScore = 0;
var drawOptions = {};

function isNumber (thing) {
  return (thing !== undefined) && typeof thing === 'number';
}

function updateReviewScoreElement (current) {
  var $reviewScore = document.querySelector('.review-score');
  var $reviewScoreValue = document.querySelector('.review-score-value');
  var currentScore = Math.round(current);
  var rank = getRankFromPercentage(currentScore);
  var newClass = rank.class;
  var newLabel = window.isInsideReview ? rank.label : currentScore;
  var regexp = new RegExp(`^rank(-inside)?-[^${newClass.split('-').pop()}]$`);
  var classList = $reviewScore.classList;

  if (classList) {
    for (var i = 0, ilen = classList.length; i < ilen; i++) {
      if (regexp.test(classList[i])) {
        classList.remove(classList[i]);
        classList.add(`rank-${newClass}`);
      }
    }
  }
  $reviewScore.setAttribute('data-score', currentScore);
  $reviewScoreValue.innerText = newLabel;
}

function getElementType (score) {
  return (score === 0 || score === 100)
    ? ELEMENT_TYPE.CIRCLE
    : ELEMENT_TYPE.PATH;
}

function polarToCartesian (centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
}

function getRankFromPercentage (scoreValue) {
  var rank = {
    'label': 'f',
    'class': 'f'
  };

  if (window.isInsideReview) {
    if (scoreValue >= 70) {
      rank = {
        'label': 'A+',
        'class': 'inside-a'
      };
    } else if (scoreValue >= 60) {
      rank = {
        'label': 'A',
        'class': 'inside-a'
      };
    } else if (scoreValue >= 50) {
      rank = {
        'label': 'B',
        'class': 'inside-b'
      };
    } else if (scoreValue >= 40) {
      rank = {
        'label': 'C',
        'class': 'inside-c'
      };
    } else {
      rank = {
        'label': 'D',
        'class': 'inside-d'
      };
    }
  } else {
    if (scoreValue >= 85) {
      rank = {
        'label': 'A',
        'class': 'a'
      };
    } else if (scoreValue >= 70) {
      rank = {
        'label': 'B',
        'class': 'b'
      };
    } else if (scoreValue >= 50) {
      rank = {
        'label': 'C',
        'class': 'c'
      };
    } else if (scoreValue >= 30) {
      rank = {
        'label': 'D',
        'class': 'd'
      };
    } else if (scoreValue >= 10) {
      rank = {
        'label': 'E',
        'class': 'e'
      };
    } else {
      rank = {
        'label': 'F',
        'class': 'f'
      };
    }
  }

  return rank;
}

function getArcPath (score, options) {
  var startAngle = 0;
  var radius = options.radius;
  var padding = options.padding;

  // endAngle can be between 1 and 359, the values 0 & 360 are handled differently
  var endAngle = Math.floor(Math.min(score * 3.6, 359)) || 1;

  var start = polarToCartesian(radius, radius, radius - padding, endAngle);
  var end = polarToCartesian(radius, radius, radius - padding, startAngle);
  var largeArcFlag = Math.floor(endAngle / 180);

  var d = [
    'M', start.x, start.y,
    'A', radius - padding, radius - padding, 0, largeArcFlag, 0, end.x, end.y
  ].join(' ');

  return d;
}

function createPath (svg, options, score) {
  var pathType = getElementType(score);
  var path = document.createElementNS(SVG_NAMESPACE, pathType);
  path.setAttribute('fill', 'none');

  if (pathType === ELEMENT_TYPE.CIRCLE) {
    path.setAttribute('cx', options.radius);
    path.setAttribute('cy', options.radius);
    path.setAttribute('r', options.radius - options.padding);
  } else if (pathType === ELEMENT_TYPE.PATH) {
    path.setAttribute('d', getArcPath(score, options));
  }

  return path;
}

function createSvg (element, options) {
  var svg = document.createElementNS(SVG_NAMESPACE, 'svg');
  svg.setAttribute('class', 'review-score-graphic');
  element.appendChild(svg);

  return svg;
}

function clearPaths (svg) {
  Object.keys(ELEMENT_TYPE).forEach(function (type) {
    var path = svg.querySelector(ELEMENT_TYPE[type]);
    path && svg.removeChild(path);
  });
}

function drawInitial (element, options, score) {
  if (score === undefined || isNaN(score)) {
    score = 0;
  }

  var svg = element.querySelector('.review-score-graphic') || createSvg(element, options);
  var path = createPath(svg, options, score);
  svg.appendChild(path);
}

var activeAnimationId = 0;
function animateTo (targetScore, drawOptions) {
  // We only allow one animation at time
  var animationId = ++activeAnimationId;

  var requestAnimationFrame = (
    window.requestAnimationFrame ||
    function (fn) {
      window.setTimeout(fn, 15);
    }
  );

  if (targetScore === undefined || targetScore === currentScore) {
    return;
  }

  // Quadratic in-out tween taken from
  // https://github.com/tweenjs/tween.js/blob/ae085330fbc0c4e7911c69e786bd3f697f95943f/src/Tween.js#L447
  function inout (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k;
    }

    return -0.5 * (--k * (k - 2) - 1);
  }

  var start = null;

  var delta = (currentScore < targetScore) ? +1 : -1;
  var difference = Math.abs(currentScore - targetScore);
  var initialScore = currentScore;

  function updateScore (newScore) {
    var currentElement = getElementType(currentScore);
    var nextElement = getElementType(newScore);
    currentScore = newScore;
    update(currentScore, currentElement !== nextElement, drawOptions);
  }

  function step (timestamp) {
    if (animationId !== activeAnimationId) {
      return;
    }

    if (!start) {
      start = timestamp;
    }

    var progress = inout((timestamp - start) / ANIMATION_DURATION);

    if (progress > 0) {
      updateScore(Math.round(initialScore + (delta * difference * progress)));
    }

    if ((timestamp - start) < ANIMATION_DURATION) {
      requestAnimationFrame(step);
    } else {
      // If we didn't finish in time, do it here
      updateScore(targetScore);
    }
  }

  requestAnimationFrame(step);
}

function update (score, clear, options) {
  var reviewScore = wooReviewScore || options.wooReviewScore;
  var svg = reviewScore.querySelector('.review-score-graphic');

  if (!svg) {
    return console.warn('Tried to update the score but svg element was not found!');
  }

  if (clear) {
    clearPaths(svg);
    return drawInitial(reviewScore, options, score);
  }

  var oldPath = svg.querySelector(ELEMENT_TYPE.PATH);

  if (!oldPath) {
    return createPath(svg, options, score);
  }

  var d = getArcPath(score, options);
  oldPath.setAttribute('d', d);
  updateReviewScoreElement(score);
}

function getPercentageFromElement (elem) {
  var $reviewScoreDataScore = elem.getAttribute('data-score');
  return $reviewScoreDataScore && parseInt($reviewScoreDataScore, 10) || 0;
}

function init (options) {
  options = options || {};

  var $reviewScore = document.querySelector('.review-score');
  if ($reviewScore) {
    var percentage = isNumber(options.score)
      ? options.score
      : getPercentageFromElement($reviewScore);

    drawOptions.widthHeight = $reviewScore.offsetWidth || DEFAULTS.scoreSize;
    drawOptions.animate = !!options.animate;
    drawOptions.padding = 2;
    drawOptions.radius = Math.floor(drawOptions.widthHeight / 2) || DEFAULTS.scoreRadius;

    createSvg($reviewScore, drawOptions);

    // Set global holder
    wooReviewScore = $reviewScore;

    if (drawOptions.animate) {
      currentScore = 0; // Animation starts from zero
      drawInitial($reviewScore, drawOptions, 0);
      animateTo(percentage, drawOptions);
    } else {
      currentScore = percentage;
      drawInitial($reviewScore, drawOptions, percentage);
    }
  }
}

function finalize (score) {
  if (window.isInsideReview) {
    updateReviewScoreElement(score);
  } else {
    return animateTo(score, drawOptions);
  }
}

module.exports = {
  init: init,
  finalize: finalize,
  _isNumber: isNumber,
  _polarToCartesian: polarToCartesian,
  _getRankFromPercentage: getRankFromPercentage,
  _getPercentageFromElement: getPercentageFromElement,
  _updateReviewScoreElement: updateReviewScoreElement,
  _animateTo: animateTo
};
